import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StepText, Title, Wrapper } from './CheckoutStepper.style'

export enum StepStatus {
    VEHICLE = 'VEHICLE',
    CONTACT = 'CONTACT',
    CONFIRM = 'CONFIRM',
    PAYMENT = 'PAYMENT'
}

interface Props {
    step: number
    noOfSteps: number
}

const CheckoutStepper: FC<Props> = ({ step = 1, noOfSteps }) => {
    const { t } = useTranslation()

    return (
        <Wrapper>
            <StepText>
                {t('checkout.payment.step')} {step}/{noOfSteps}
            </StepText>
            <Title>
                {step === 1 && t('checkout.vehicleStep')}
                {step === 2 && t('checkout.contactStep')}
                {step === 3 && t('checkout.confirmStep')}
                {step === 4 && t('checkout.paymentStep')}
            </Title>
        </Wrapper>
    )
}

export default CheckoutStepper
